export const infoSolid = [
  '0 0 32 32',
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-6 h-6">
  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-10.25a.75.75 0 10-1.5 0v5.5a.75.75 0 101.5 0v-5.5zm-.75-2.75a.75.75 0 100 1.5.75.75 0 000-1.5z" clip-rule="evenodd" />
</svg>
`,
]
